import React from 'react';
import InvoiceApp from './InvoiceApp';

function App() {
  return (
    <div>
      <InvoiceApp />
    </div>
  );
}

export default App;